import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

const StyleSection = () => {
  const looks = [
    {
      image: "https://images.unsplash.com/photo-1588186941799-f9a4fc54ff1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwd29tYW4lMjBmYXNoaW9uJTIwbW9kZWwlMjBvZmZpY2UlMjBzdHlsZSUyMGJsYXplcnxlbnwwfHx8fDE3NzM0MDA3MTJ8MA&ixlib=rb-4.1.0&q=85",
      title: "Look Oficina",
      description: "Elegancia profesional"
    },
    {
      image: "https://images.unsplash.com/photo-1592327877233-90b9bfd92e48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHx3b21hbiUyMGNhc3VhbCUyMGNoaWMlMjBzdHJlZXQlMjBzdHlsZSUyMGJlaWdlJTIwY29hdHxlbnwwfHx8fDE3NzM0MDA3MTN8MA&ixlib=rb-4.1.0&q=85",
      title: "Casual Urbano",
      description: "Comodidad con estilo"
    },
    {
      image: "https://images.unsplash.com/photo-1768508947982-de0fe8d0792b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwd29tYW4lMjBldmVuaW5nJTIwZHJlc3MlMjBkaW5uZXIlMjBldmVudHxlbnwwfHx8fDE3NzM0MDA3MTN8MA&ixlib=rb-4.1.0&q=85",
      title: "Evento Especial",
      description: "Brilla en cada ocasión"
    }
  ];

  return (
    <section data-testid="style-section" className="section-padding bg-white">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-sm font-sans tracking-[0.2em] uppercase text-[#C8A96A] mb-4 block">
            Tu estilo, tu identidad
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#111111] mb-6">
            Estilo, elegancia y versatilidad
          </h2>
          <p className="text-lg font-sans text-[#111111]/70 leading-relaxed">
            En StyleOutlet seleccionamos prendas femeninas pensadas para la mujer actual: 
            elegantes, cómodas y fáciles de combinar. Desde vestidos sofisticados hasta 
            abrigos y blusas versátiles que elevan cualquier look.
          </p>
        </div>

        {/* Image Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-12">
          {looks.map((look, index) => (
            <div 
              key={index}
              data-testid={`style-look-${index}`}
              className="group relative overflow-hidden aspect-[3/4] cursor-pointer img-zoom card-hover"
            >
              <img
                src={look.image}
                alt={look.title}
                className="w-full h-full object-cover"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#111111]/80 via-[#111111]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              
              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                <h3 className="font-serif text-2xl text-white mb-2">{look.title}</h3>
                <p className="font-sans text-white/80">{look.description}</p>
              </div>

              {/* Badge */}
              <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                <span className="text-xs font-sans font-bold tracking-wider uppercase text-[#111111]">
                  {look.title}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a 
            href="https://styleoutlet.es/28-top-ventas" 
            target="_blank" 
            rel="noopener noreferrer"
            data-testid="style-cta"
          >
            <Button className="bg-[#111111] hover:bg-[#C8A96A] text-white px-10 py-6 text-base font-bold tracking-widest uppercase transition-all duration-300 cursor-pointer">
              Explorar novedades
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default StyleSection;
